import React from 'react';
import Section from '../components/Section';
import DropdownField from '../components/DropdownField';
import ChipSelect from '../components/ChipSelect';
import TextField from '../components/TextField';

const HYGIENE_RATING_OPTIONS = [
  '✅ All clean — no issues',
  '⚠️ Minor issues — sorted during shift',
  '❌ Serious issue — needs attention',
];

const HYGIENE_ISSUE_OPTIONS = [
  'Kitchen cleaning',
  'Food prep area',
  'Counter',
  'Washroom',
  'Waste disposal',
  'Pest sighting',
  'Staff hygiene',
  'Other',
];

function S5_Hygiene({ data, onChange }) {
  const showIssues =
    data.hygiene_rating &&
    data.hygiene_rating !== '✅ All clean — no issues';

  return (
    <Section title="Hygiene and cleanliness">
      <DropdownField
        label="How was hygiene and cleanliness today?"
        options={HYGIENE_RATING_OPTIONS}
        value={data.hygiene_rating}
        onChange={(v) => onChange('hygiene_rating', v)}
        placeholder="Select (optional)"
      />

      {showIssues && (
        <ChipSelect
          label="What was the issue?"
          options={HYGIENE_ISSUE_OPTIONS}
          selected={data.hygiene_issues || []}
          onChange={(v) => onChange('hygiene_issues', v)}
        />
      )}

      <TextField
        label="Any details?"
        value={data.hygiene_notes || ''}
        onChange={(v) => onChange('hygiene_notes', v)}
        multiline
        maxLength={200}
        placeholder="Optional — add any details here"
      />
    </Section>
  );
}

export default S5_Hygiene;
